import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const money = (cents) =>
  `${(cents || 0) < 0 ? "−" : ""}US$${(Math.abs(cents || 0) / 100).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtExpiry = (iso) => (iso ? new Intl.DateTimeFormat("en-CA", { timeZone: "UTC", month: "short", day: "numeric", year: "numeric" }).format(new Date(iso)) : "");

export const fmtDate = (iso, tz, opts = {}) => {
  if (!iso) return "";
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: tz || "America/Toronto",
    month: "short", day: "numeric", year: "numeric", ...opts,
  }).format(new Date(iso));
};

export const TZ_ABBR = { "America/Vancouver": "PT", "America/Edmonton": "MT", "America/Regina": "CST", "America/Winnipeg": "CT", "America/Toronto": "ET", "America/Halifax": "AT", "America/St_Johns": "NT" };

export const fmtClock = (hhmm) => {
  const [h, m] = hhmm.split(":").map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${h < 12 ? "a.m." : "p.m."}`;
};

export const fmtTime = (iso, tz) => {
  if (!iso) return "";
  const t = new Intl.DateTimeFormat("en-US", { timeZone: tz || "America/Toronto", hour: "numeric", minute: "2-digit", hourCycle: "h23" }).format(new Date(iso));
  return `${fmtClock(t)} ${TZ_ABBR[tz || "America/Toronto"] || ""}`.trim();
};

export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("en-CA", { dateStyle: "medium", timeStyle: "short" }) : "");

export const RISK =
  "Trading involves risk. You can lose some or all of your money. Results vary and past results do not predict future results. Education only, not investment advice.";
